import Heading from '@components/UI/Typography/Heading';
import useMods from '@hooks/useMods';
import RenderIf from '@utils/renderIf';

import PropTypes from 'prop-types';
import React from 'react';

import BlockquoteAuthor from './BlockquoteAuthor';
import BlockquoteBody from './BlockquoteBody';
import BlockquoteFooter from './BlockquoteFooter';

const Blockquote = ({ mods, mix, icon, body, author, reviewLogo, date, className: classNameTail, authorConfig }) => {
    const { className } = useMods(Blockquote, { mix, mods });

    return (
        <div className={ className + (classNameTail ? ' ' + classNameTail : '') }>
            { icon }
            <BlockquoteBody>
                <Heading tag='h3'>
                    { body }
                </Heading>
            </BlockquoteBody>
            <BlockquoteFooter className='justify-between'>
                <div className='flex flex-wrap items-center gap-2'>
                    <BlockquoteAuthor
                        config={authorConfig}
                        author={ author }
                    />
                    { reviewLogo }
                </div>
                <RenderIf isTrue={ date }>
                    <div className='text-[16px] text-neutral-900 font-[400]'>{ date }</div>
                </RenderIf>
            </BlockquoteFooter>
        </div>
    );
};

Blockquote.displayName = 'Blockquote';

Blockquote.propTypes = {
    author: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
    children: PropTypes.node,
    icon: PropTypes.node.isRequired,
    mix: PropTypes.object,
    mods: PropTypes.object,
    reviewLogo: PropTypes.node.isRequired
};

Blockquote.defaultProps = {
    mix: {},
    mods: {}
};

export default Blockquote;
